<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>公司管理</el-breadcrumb-item>
            <el-breadcrumb-item>公司列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div
            style="
                background-color: #fff;
                padding: 10px;
                margin-top: 10px;
                position: absolute;
                top: 54px;
                bottom: 20px;
                right: 10px;
                left: 10px;
            "
        >
            <div>
                <el-input v-model="filters.search" placeholder="请输入关键字查询" style="width: 215px"></el-input>
                <el-button type="primary" style="margin-left: 15px" @click="seachRole">搜索</el-button>
                <span class="dz-zz-right-btn-box">
                    <el-button type="primary" @click="synchroData" :disabled="btnClickStatus"
                        ><i class="el-icon-refresh"></i>&nbsp;{{ btnClickStatus ? '同步中' : '认证同步' }}</el-button
                    >
                    <el-button type="primary" @click="DDLVis = true"><i class="el-icon-aim"></i>&nbsp;执行DDL</el-button>
                    <el-button type="primary" :disabled="checking" @click="checkDataBase"
                        ><i class="el-icon-menu"></i>&nbsp;检查数据库</el-button
                    >
                    <el-button type="primary" @click="addRoleDialogShow"><i class="el-icon-lx-add"></i>&nbsp;新增</el-button>
                    <el-button type="danger" @click="batchRemove"><i class="el-icon-lx-delete"></i>&nbsp;批量删除</el-button>
                </span>
            </div>
            <div class="dz-zz-table-box">
                <el-table
                    ref="multipleTable"
                    :data="roleList"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                    v-loading="listLoading"
                    :height="tableHeight"
                    @selection-change="selsChange"
                >
                    <el-table-column type="selection" width="55" align="center"> </el-table-column>
                    <el-table-column label="公司名称" align="center">
                        <template slot-scope="scope">
                            <span class="dz-detail-btn">{{ scope.row.name }}<i class="el-icon-caret-right"></i></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="开通功能" prop="webFunctions" align="center">
                        <template scope="scope">
                            <div v-show="scope.row.webFunctions != ''">
                                <span style="font-weight: bold; color: red">PC：</span>
                                <span>{{ scope.row.webFunctions }}</span>
                            </div>
                            <div v-show="scope.row.appFunctions != ''">
                                <span style="font-weight: bold; color: red">APP：</span>
                                <span>{{ scope.row.appFunctions }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="公司状态" width="80" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.state == '1' ? '正常' : '禁用' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column width="250" label="开通日期" prop="registrationDate" align="center"> </el-table-column>
                    <el-table-column width="250" label="管理员" prop="admins" align="center"> </el-table-column>
                    <el-table-column label="操作" width="400" show-overflow-tooltip align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="success" @click="editRole(scope.row)"
                                ><i class="el-icon-lx-edit"></i>&nbsp;编辑</el-button
                            >
                            <el-button size="mini" type="danger" @click="deleteRole(scope.row)"
                                ><i class="el-icon-lx-delete"></i>&nbsp;删除</el-button
                            >
                            <!--    <el-button
                                    size="mini"
                                    type="warning"
                                    @click="addFun(scope.row)"><i class="el-icon-plus"></i>&nbsp;添加功能</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block">
                <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="pageSize"
                    :total="total"
                    :current-page.sync="currentPage"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog title="执行DDL" :visible.sync="DDLVis" width="30%" :before-close="hidenDDL">
            <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="DDL"> </el-input>
            <span slot="footer">
                <el-button @click="hidenDDL">取消</el-button>
                <el-button @click="DDLMethod" type="primary">执行</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="addForm.company.id ? '编辑公司信息' : '新增公司信息'"
            :visible.sync="dialogAddVisible"
            :close-on-click-modal="false"
            width="62%"
            top="50px"
            :before-close="addRoleDialogHide"
        >
            <div style="padding-right: 10px; box-sizing: border-box; max-height: 600px; overflow: auto">
                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <el-form-item label="公司名称" :label-width="formLabelWidth" prop="company.name">
                        <el-input v-model="addForm.company.name" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="logo上传" :label-width="formLabelWidth">
                        <el-upload
                            class="avatar-uploader"
                            accept="image/*"
                            action=""
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>

                    <el-form-item v-show="addForm.company.id" label="注册时间" :label-width="formLabelWidth">
                        <el-input v-model="addForm.company.registrationDate" autocomplete="off" readonly :disabled="true"></el-input>
                    </el-form-item>

                    <el-form-item v-show="addForm.company.id" label="公司状态" :label-width="formLabelWidth">
                        <el-radio-group v-model="addForm.company.state">
                            <el-radio :label="1">正常</el-radio>
                            <el-radio :label="2">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="智慧工地URL地址" :label-width="formLabelWidth">
                        <el-input v-model="addForm.company.smartSiteUrl"></el-input>
                    </el-form-item>
                    <el-row style="height: 500px; width: 90%">
                        <el-form-item label="PC端功能" :label-width="formLabelWidth">
                            <!-- <div class="function_box">
                                <label for="" class="hide">11</label>
                                <treeselect
                                    v-model="pcValue"
                                    :multiple="true"
                                    :options="webTreeData"
                                    value-consists-of="ALL_WITH_INDETERMINATE"
                                    :alwaysOpen="true"
                                    :limit="1"
                                    placeholder="请选择PC端功能"
                                    :normalizer="normalizer"
                                    :limit-text="(count) => `更多已选${count}项`"
                                >
                                    <p
                                        style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 90%"
                                        slot="option-label"
                                        slot-scope="{ node }"
                                        :title="node.label"
                                    >
                                        <template> {{ node.label }}</template>
                                    </p>
                                </treeselect>
                            </div> -->
                            <el-input placeholder="输入关键字进行过滤" clearable v-model="filterText"> </el-input>
                            <el-tree
                                :props="defaultProps"
                                :data="webTreeData"
                                show-checkbox
                                node-key="id"
                                @check="handleCheckChange"
                                :render-content="renderContent"
                                @node-expand="handleExpand"
                                :filter-node-method="filterNode"
                                ref="pctree"
                            >
                                <!-- <div slot-scope="{ node, data }" class="tree-node">
                                    <el-tooltip
                                        :content="node.label"
                                        :disabled="isShowTooltip"
                                        :open-delay="300"
                                        placement="top"
                                        effect="dark"
                                    >
                                        <span class="over-ellipsis" @mouseover="mouseOver($event)">
                                            {{ node.name }}
                                        </span>
                                    </el-tooltip>
                                </div> -->
                                <!-- //重点在类 custom-tree-node 和 :title="node.label" v-text="node.label" 上 -->
                                <!-- <span class="custom-tree-node" slot-scope="{ node, data }" :title="node.label" v-text="node.label">
                              
                                   
                                </span> -->
                            </el-tree>
                        </el-form-item>
                    </el-row>
                    <el-row style="height: 500px; width: 90%">
                        <el-form-item label="APP端菜单权限" :label-width="formLabelWidth">
                            <!-- <div class="function_box">
                                <label for="">菜单权限</label>
                                <treeselect
                                    v-model="appRoleValue"
                                    :multiple="true"
                                    :options="appTreeData"
                                    value-consists-of="ALL_WITH_INDETERMINATE"
                                    :alwaysOpen="true"
                                    :limit="1"
                                    placeholder="请选择app端权限功能"
                                    :normalizer="normalizer"
                                    :limit-text="(count) => `更多已选${count}项`"
                                    @select="addAppRoleId"
                                    @deselect="deleteAppRoleId"
                                />
                            </div> -->
                            <el-input placeholder="输入关键字进行过滤" clearable v-model="filterText1"> </el-input>
                            <el-tree
                                :props="defaultProps"
                                :data="appTreeData"
                                show-checkbox
                                node-key="id"
                                @check="handleCheckChange1"
                                :render-content="renderContent2"
                                @node-expand="handleExpand"
                                :filter-node-method="filterNode"
                                ref="apptree"
                            >
                                <div slot-scope="{ node }" class="tree-node">
                                    <el-tooltip
                                        :content="node.label"
                                        :disabled="isShowTooltip"
                                        :open-delay="300"
                                        placement="top"
                                        effect="dark"
                                    >
                                        <span class="over-ellipsis" @mouseover="mouseOver($event)">
                                            {{ node.name }}
                                        </span>
                                    </el-tooltip>
                                </div>
                            </el-tree>
                        </el-form-item>
                    </el-row>
                    <el-row style="height: 500px; width: 90%">
                        <el-form-item label="APP端菜单显示" :label-width="formLabelWidth">
                            <!-- <div class="function_box">
                                <label for="">菜单显示</label>
                                <treeselect
                                    v-model="appShowValue"
                                    :multiple="true"
                                    :options="appTreeData"
                                    value-consists-of="ALL_WITH_INDETERMINATE"
                                    :alwaysOpen="true"
                                    :limit="1"
                                    placeholder="请选择app端显示功能"
                                    :normalizer="normalizer"
                                    :limit-text="(count) => `更多已选${count}项`"
                                    @select="addAppShowId"
                                    @deselect="deleteAppShowId"
                                />
                            </div> -->
                            <el-input placeholder="输入关键字进行过滤" clearable v-model="filterText2"> </el-input>
                            <el-tree
                                :props="defaultProps"
                                :data="appTreeData"
                                show-checkbox
                                node-key="id"
                                @check="handleCheckChange2"
                                :render-content="renderContent2"
                                @node-expand="handleExpand"
                                :filter-node-method="filterNode"
                                ref="appShowtree"
                            >
                                <div slot-scope="{ node }" class="tree-node">
                                    <el-tooltip
                                        :content="node.label"
                                        :disabled="isShowTooltip"
                                        :open-delay="300"
                                        placement="top"
                                        effect="dark"
                                    >
                                        <span class="over-ellipsis" @mouseover="mouseOver($event)">
                                            {{ node.name }}
                                        </span>
                                    </el-tooltip>
                                </div>
                            </el-tree>
                        </el-form-item>
                    </el-row>
                </el-form>

                <div style="width: 100%">
                    <p class="part_title"><span data-v-0cae3970="" class="shu_line"></span><i style="color: red">*</i> 管理员</p>
                    <el-form style="width: 100%" :model="managerList" ref="managerList">
                        <el-table ref="multipleTable" :data="managerListNew" tooltip-effect="dark" style="width: 100%; height: auto" border>
                            <el-table-column label="编号" type="index" align="center" color="#fff" width="120"> </el-table-column>
                            <el-table-column width="233" label="管理员姓名">
                                <template scope="scope">
                                    <el-form-item
                                        style="margin-bottom: 0"
                                        :prop="'lists.' + scope.$index + '.userName'"
                                        :rules="[{ required: true, message: '域名不能为空', trigger: 'blur' }]"
                                    >
                                        <el-input v-model="scope.row.userName" placeholder="请输入用户名"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="管理员账号(必须是手机号码)" width="300" prop="remindType">
                                <template scope="scope">
                                    <el-form-item
                                        style="margin-bottom: 0"
                                        :prop="'lists.' + scope.$index + '.tel'"
                                        :rules="[{ required: true, message: '域名不能为空', trigger: 'blur' }]"
                                    >
                                        <el-input v-model="scope.row.tel" placeholder="请输入"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="300" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button size="mini" type="success" @click="addManager(scope.$index)"
                                        ><i class="el-icon-lx-edit"></i>&nbsp;添加</el-button
                                    >
                                    <el-button
                                        size="mini"
                                        type="danger"
                                        :disabled="managerListNew.length == 1"
                                        @click="deleteManager(scope.row)"
                                        ><i class="el-icon-lx-delete"></i>&nbsp;删除</el-button
                                    >
                                    <el-button size="mini" v-if="addForm.company.id" type="primary" @click="resetPwd(scope.row)"
                                        ><i class="el-icon-postcard"></i>&nbsp;重置密码</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="addRoleDialogHide">取 消</el-button>
                <el-button type="primary" @click="addSubmit" :loading="addLoading">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="功能管理"
            :visible.sync="funDialogVisible"
            :close-on-click-modal="false"
            width="1000px"
            :before-close="addFunDialogHide"
        >
            <div style="text-align: center">
                <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="chooseFrom.functions"
                    filterable
                    :titles="['可选功能', '已选功能']"
                    :button-texts="['删除', '添加']"
                    :format="{
                        noChecked: '${total}',
                        hasChecked: '${checked}/${total}'
                    }"
                    @change="handleChange"
                    :data="funData"
                >
                    <span slot-scope="{ option }">{{ option.label }}</span>
                </el-transfer>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="addFunDialogHide">取 消</el-button>
                <el-button type="primary" @click="saveFun">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import { get, post, put, deletes, patch } from '@/api/fetch.js';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Treeselect from '@riophae/vue-treeselect';
import url from '@/api/serviceAPI.config.js';
export default {
    name: 'village',
    data() {
        return {
            // defaultProps:{
            //     label: name,
            //     children: children
            // },
            btnClickStatus: false,
            // define the default value
            appRoleValue: [],
            appShowValue: [],
            pcValue: [],
            // define options
            appTreeData: [],
            webTreeData: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            timer: null,
            imageUrl: '',
            DDL: '',
            DDLVis: false,
            input: '',
            tableHeight: document.body.clientHeight - 255,
            pageNum: 0,
            pageSize: 10,
            chooseFrom: {
                functions: [],
                companyId: ''
            },
            listLoading: false, //loading'
            funData: [],
            filters: {
                search: ''
            },
            dialogAddVisible: false,
            dialogManagerAddVisible: false,
            funDialogVisible: false,
            formLabelWidth: '110px',
            checking: false,
            addForm: {
                company: {
                    name: '',
                    state: '',
                    smartSiteUrl: ''
                },
                tenant: {
                    functions: [],
                    appFunctions: []
                }
            },
            rules: {
                company: {
                    name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                    remindType: []
                }
            },
            addLoading: false,
            total: null,
            roleList: [],
            managerList: {
                lists: [
                    {
                        userName: '',
                        tel: '',
                        editStatus: '1'
                    }
                ]
            },
            sels: [],
            currentPage: 0,
            otherFields: {},
            isIndeterminate: false,
            PCcheckAll: false,
            pcOptions: [
                '合同管理',
                '人员管理',
                '质量与安全',
                '检测管理',
                '安全教育',
                '计量支付',
                '变更管理',
                '收方管理',
                '核价管理',
                '协作管理',
                '成果资料管理',
                '统计报表',
                '系统配置'
            ],
            isAPPIndeterminate: false,
            APPcheckAll: false,
            // AppOptions: [
            //     '质安管理-质安巡检',
            //     '质安管理-岗前教育',
            //     '质安管理-质安技术交底',
            //     '人员管理-人员履职',
            //     '人员管理-我的考勤',
            //     '人员管理-值班打卡',
            //     '通用功能-协作管理',
            //     '通用功能-收方签证',
            //     '通用功能-成果资料',
            //     '通用功能-合同管理',
            //     '数据分析-月度概览',
            //     '数据分析-项目隐患汇总表',
            //     '数据分析-隐患条目频次图',
            //     '施工协作-计量支付',
            //     '施工协作-变更管理',
            //     '施工协作-核价管理',
            //     '疫情监控-疫情数据填报',
            //     '检测管理-原材料报验',
            //     '检测管理-材料检测',
            //     '检测管理-现场试验'
            // ]
            AppOptions: ['质安管理', '人员管理', '通用功能', '数据分析', '施工协作', '疫情监控', '检测管理'],
            filterText: '',
            filterText1: '',
            filterText2: ''
        };
    },
    components: {
        Treeselect
    },
    computed: {
        // 使用计算属性 过滤数组数据
        // 也可以直接在getData中使用 filter 过滤
        managerListNew: function () {
            return this.managerList.lists.filter((data) => {
                return data.editStatus != '9';
            });
        }
    },
    watch: {
        pcValue(newVal, oldVal) {
            console.log(newVal);
        },
        filterText(val) {
            this.$refs.pctree.filter(val);
        },
        filterText1(val) {
            this.$refs.apptree.filter(val);
        },
        filterText2(val) {
            this.$refs.appShowtree.filter(val);
        }
    },
    created() {},
    activated() {},
    deactivated() {},
    mounted() {
        this.getInitData();
        this.getRole();
        this.changeCss(); //默认调用此方法将子节点渲染为横向排列
        // this.$nextTick(() => {
        //     var threeFuse = document.getElementsByClassName('threeFuse');
        //     for (var i = 0; i < threeFuse.length; i++) {
        //         threeFuse[i].parentNode.style.cssFloat = 'left';
        //         threeFuse[i].parentNode.style.styleFloat = 'left';
        //     }
        // });
    },
    methods: {
        mouseOver(event) {
            console.log(event);
            //在data里边记得要定义一个isShowTooltip默认为false
            this.isShowTooltip = event.currentTarget.scrollWidth <= event.currentTarget.clientWidth;
            // console.log("222");
        },

        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        handleExpand() {
            // 因为该函数执行在renderContent函数之前，所以得加this.$nextTick()
            this.$nextTick(() => {
                this.changeCss();
            });
        },
        renderContent(h, { node, data }) {
            let className = '';
            if (node.level == 3) {
                className = 'threeFuse';
            }
            // 由于项目中有三级菜单也有四级级菜单，就要在此做出判断
            //   if (node.level == 4) {
            //     classname = 'threeFuse'
            //   }
            //   if (node.level == 3 && node.childNodes.length == 0) {
            //     classname = 'threeFuse'
            //   }
            return <span class={className}>{data.name}</span>;
        },
        renderContent2(h, { node, data }) {
            let className = '';
            if (node.level == 2) {
                className = 'threeFuse';
            }
            // 由于项目中有三级菜单也有四级级菜单，就要在此做出判断
            //   if (node.level == 4) {
            //     classname = 'threeFuse'
            //   }
            //   if (node.level == 3 && node.childNodes.length == 0) {
            //     classname = 'threeFuse'
            //   }
            return <span class={className}>{data.name}</span>;
        },
        changeCss() {
            this.$nextTick(() => {
                var threeFuse = document.getElementsByClassName('threeFuse');
                for (var i = 0; i < threeFuse.length; i++) {
                    threeFuse[i].parentNode.style.cssFloat = 'left';
                    threeFuse[i].parentNode.style.styleFloat = 'left';
                }
            });
        },
        handleCheckChange(obj1, obj2) {
            console.log(obj1);
            console.log(obj2);
            this.pcValue = obj2.checkedKeys.concat(obj2.halfCheckedKeys);
        },
        handleCheckChange1(obj1, obj2) {
            console.log(obj1);
            console.log(obj2);
            this.appRoleValue = obj2.checkedKeys.concat(obj2.halfCheckedKeys);
        },
        handleCheckChange2(obj1, obj2) {
            console.log(obj1);
            console.log(obj2);
            this.appShowValue = obj2.checkedKeys.concat(obj2.halfCheckedKeys);
            console.log(this.appShowValue);
        },
        pcTreeSelect(node) {
            console.log(node);
            setTimeout(() => {
                console.log(this.pcValue);
            }, 1000);
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },

        getInitData() {
            get(url.menu.importOnDutySettingMessage + '?application=Web').then((res) => {
                this.deleteEmptyChildren(res.data);
                this.webTreeData = res.data;
                console.log('webTreeData', this.webTreeData);
            });
            get(url.menu.importOnDutySettingMessage + '?application=App').then((res) => {
                this.deleteEmptyChildren(res.data);
                this.appTreeData = res.data;
                console.log('appTreeData', this.appTreeData);
            });
        },
        deleteEmptyChildren(data) {
            data.forEach((item) => {
                if (item.children.length) {
                    this.deleteEmptyChildren(item.children);
                } else {
                    delete item.children;
                }
            });
        },
        handleCheckAllChange(val) {
            this.addForm.tenant.functions = val ? this.pcOptions : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.PCcheckAll = checkedCount === this.pcOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.pcOptions.length;
        },
        handleCheckAllChangeAPP(val) {
            this.addForm.tenant.appFunctions = val ? this.AppOptions : [];
            this.isAPPIndeterminate = false;
        },
        handleCheckedCitiesChangeAPP(value) {
            let checkedCount = value.length;
            this.APPcheckAll = checkedCount === this.AppOptions.length;
            this.isAPPIndeterminate = checkedCount > 0 && checkedCount < this.AppOptions.length;
        },
        DDLMethod() {
            get(url.company.executeDDL, { ddl: this.DDL }).then((res) => {
                console.log(res);
            });
        },
        hidenDDL() {
            this.DDL = '';
            this.DDLVis = false;
        },
        //改变分页信息
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getRole();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getRole();
        },
        //获取列表
        getRole() {
            let para = Object.assign({ pageNum: this.pageNum ? this.pageNum - 1 : this.pageNum, pageSize: this.pageSize }, this.filters);
            this.listLoading = true;
            get(url.company.searchList, para)
                .then((res) => {
                    console.log('res', res);
                    this.total = res.data.totalNum;
                    this.roleList = res.data.datas;
                    this.roleList.forEach((item, index) => {
                        item.webFunctions = '';
                        item.appFunctions = '';
                        if (item.webMenu.length > 0) {
                            item.webMenu.forEach((webItem, indexs) => {
                                item.webFunctions = item.webFunctions + webItem + (indexs == item.webMenu.length - 1 ? '' : ',');
                            });
                        }
                        if (item.appMenu.length > 0) {
                            item.appMenu.forEach((appItem, indexs) => {
                                item.appFunctions = item.appFunctions + appItem + (indexs == item.appMenu.length - 1 ? '' : ',');
                            });
                        }
                    });
                    console.log('roles', this.roleList);
                    this.listLoading = false;
                    this.$forceUpdate();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //显示添加村组弹框
        addRoleDialogShow() {
            this.dialogAddVisible = true;
        },
        //检查数据库
        checkDataBase() {
            this.$message({
                message: '已开始检查...',
                type: 'success',
                duration: 1500
            });
            this.checking = true;
            get(url.company.dbChangeCheck)
                .then((res) => {
                    if ((res.status = 200)) {
                        this.$message({
                            message: '检查完毕',
                            type: 'success',
                            duration: 1500
                        });
                        this.checking = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addManagerDialogShow() {
            this.dialogManagerAddVisible = true;
        },
        //隐藏添加村组弹框
        addRoleDialogHide() {
            this.pcValue = [];
            this.appValue = [];
            this.dialogAddVisible = false;
            this.addForm = {
                company: {
                    name: '',
                    id: '',
                    state: ''
                },
                file: '',
                tenant: {
                    functions: ['基础模块'],
                    appFunctions: []
                }
            };
            this.imageUrl = '';
            this.managerList.lists = [
                {
                    userName: '',
                    tel: '',
                    editStatus: '1'
                }
            ];
            (this.appRoleValue = []), (this.appShowValue = []), this.$refs.addForm.clearValidate();
            this.$refs.managerList.clearValidate();
        },
        //隐藏功能弹框
        addFunDialogHide() {
            this.funDialogVisible = false;
        },
        // 新增/编辑 提交事件
        addSubmit: function () {
            console.log('managerList', this.managerList.lists);
            let itemData = this.managerList.lists;
            for (let i = 0; i < itemData.length; i++) {
                let inx = i + 1;
                let testWay = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (itemData[i].editStatus == '9') {
                    continue;
                } else {
                    if (itemData[i].userName.replace(/^\s*|\s*$/g, '') == '' || itemData[i].userName.replace(/^\s*|\s*$/g, '') == null) {
                        this.$message.error('第' + inx + '行管理员姓名不能为空');
                        return;
                    }
                    if (!testWay.test(itemData[i].tel)) {
                        this.$message.error('第' + inx + '行管理员电话格式错误');
                        return;
                    }
                }
            }

            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                let pm = new FormData();

                for (let i in this.addForm) {
                    let item = this.addForm[i];
                    if (i == 'file') pm.append(i, item);
                    else {
                        for (let j in item) {
                            if (j != 'registrationDate') {
                                let _value = item[j] || '无';
                                let _key = i + '.' + j;
                                /*pm[_key]=item[j];*/
                                pm.append(_key, item[j]);
                            }
                        }
                    }
                }
                //管理员
                for (let i = 0; i < this.managerList.lists.length; i++) {
                    let item = this.managerList.lists[i];
                    if (!item.editStatus && this.addForm.company.id) {
                        //如果编辑里，不是新增的和删除的，就是不变的或修改的
                        if (item.userNameOld != item.userName || item.telOld != item.tel) {
                            item.editStatus = 2;
                        }
                    }
                    delete item.userNameOld;
                    delete item.telOld;

                    for (let j in item) {
                        let key = 'companyUserVos' + '[' + i + '].' + j;
                        if (!this.addForm.company.id && j == 'editStatus') {
                            //添加
                            console.log('不加');
                        } else {
                            if (j == 'id') {
                                //删除和编辑加id
                                if (item.editStatus == '9' || item.editStatus == '2') {
                                    /*pm[key]=item[j];*/
                                    pm.append(key, item[j]);
                                }
                            } else {
                                if (item[j]) /*pm[key]=item[j];*/ pm.append(key, item[j]);
                            }
                        }
                    }
                }
                pm.append('companyUserVos[0].status', 1);
                // 创建实例时设置配置的默认值
                var instance = axios.create();
                // 在实例已创建后修改默认值
                /*instance.defaults.headers.post['Content-Type'] = 'application/json';*/
                this.$refs.addForm.validate((valid) => {
                    this.$refs.managerList.validate((valid1) => {
                        if (valid && valid1) {
                            // 创建实例时设置配置的默认值
                            this.addLoading = true;
                            if (this.addForm.company.id) {
                                // 修改
                                // 在实例已创建后修改默认值
                                this.dialogAddVisible = false;
                                let organAxios = axios.create();
                                organAxios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                                organAxios
                                    .put(url.company.edit, pm)
                                    .then((result) => {
                                        this.dialogAddVisible = false;
                                        if (result.data.status == 200) {
                                            let instence = axios.create();
                                            instence.defaults.headers.post['Content-Type'] = 'multipart/json';
                                            instence
                                                .post(url.menu.grantMenu, {
                                                    companyId: this.addForm.company.id,
                                                    // grantMenuIdList: this.pcValue.concat(this.appValue)
                                                    grantWebMenuIdList: this.pcValue,
                                                    grantAppMenuIdList: this.appRoleValue,
                                                    grantAppMenuShowList: this.appShowValue
                                                })
                                                .then((res) => {
                                                    if ((res.data.status == 200) & (res.data.message == '授权菜单成功')) {
                                                        this.$message({
                                                            message: '操作成功！',
                                                            type: 'success',
                                                            duration: 1500
                                                        });
                                                    } else {
                                                        this.$message({
                                                            message: res.data.message,
                                                            type: 'error',
                                                            duration: 1500
                                                        });
                                                    }
                                                });
                                        } else {
                                            this.$message({
                                                message: result.message,
                                                type: 'error',
                                                duration: 1500
                                            });
                                        }
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })
                                    .finally(() => {
                                        this.getRole();
                                        this.addRoleDialogHide();
                                        this.addLoading = false;
                                    });
                            } else {
                                // 新增
                                let organAxios = axios.create();
                                organAxios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                                organAxios
                                    .post(url.company.add, pm)
                                    .then((result) => {
                                        this.dialogAddVisible = false;
                                        if (result.data.status == 200) {
                                            console.log(result);
                                            let instence = axios.create();
                                            instence.defaults.headers.post['Content-Type'] = 'multipart/json';
                                            instence
                                                .post(url.menu.grantMenu, {
                                                    companyId: result.data.data.id,
                                                    // grantMenuIdList: this.pcValue.concat(this.appValue)
                                                    grantWebMenuIdList: this.pcValue,
                                                    grantAppMenuIdList: this.appRoleValue,
                                                    grantAppMenuShowList: this.appShowValue
                                                })
                                                .then((res) => {
                                                    if ((res.data.status == 200) & (res.data.message == '授权菜单成功')) {
                                                        this.$message({
                                                            message: '操作成功！',
                                                            type: 'success',
                                                            duration: 1500
                                                        });
                                                    } else {
                                                        this.$message({
                                                            message: res.data.message,
                                                            type: 'error',
                                                            duration: 1500
                                                        });
                                                    }
                                                });
                                        } else {
                                            this.$message({
                                                message: result.data.message,
                                                type: 'error',
                                                duration: 1500
                                            });
                                        }
                                    })
                                    .catch((err) => {
                                        console.log('err', err);
                                    })
                                    .finally(() => {
                                        this.getRole();
                                        this.addRoleDialogHide();
                                        this.addLoading = false;
                                    });
                            }
                        }
                    });
                });
            });
        },
        //搜索
        seachRole: function () {
            this.pageNum = 0;
            this.pageSize = 10;
            this.currentPage = 0;
            this.getRole();
            this.handleCurrentChange(0);
        },
        //删除
        deleteRole: function (row) {
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.listLoading = true;
                    deletes(url.company.delete + '?companyId=' + row.id).then((res) => {
                        this.listLoading = false;
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getRole();
                    });
                })
                .catch(() => {});
            // this.batchRemove()
        },
        // 显示编辑界面
        editRole(row) {
            this.dialogAddVisible = true;
            //this.addForm = Object.assign({}, row);  //有现获取列表信息
            this.getRoleDeatil(row.id);
        },
        addFun(row) {
            this.funDialogVisible = true;
            this.chooseFrom.companyId = row.id;
            get(url.fun.companyFunction, { companyId: row.id }).then((res) => {
                let { allFunction, companyFunction } = res;
                let resule = allFunction.map((value) => {
                    value = {
                        key: value.id,
                        label: value.functionName
                    };
                    return value;
                });
                this.funData = resule;
                let resuleChoose = companyFunction.map((value) => {
                    value = value.id;
                    return value;
                });
                this.chooseFrom.functions = resuleChoose;
            });
        },
        //回填详情
        getRoleDeatil(id) {
            // 获取Web APP权限信息
            get(url.menu.ownMenu, {
                companyId: id
                // application: 'Web'
            }).then((res) => {
                this.pcValue = res.data.grantWebMenuIdList;
                this.appRoleValue = res.data.grantAppMenuIdList;
                this.appShowValue = res.data.grantAppMenuShowList;
                console.log('pcValue', this.pcValue);
                // this.$refs.pctree.setCheckedKeys(this.pcValue);
                // this.$refs.apptree.setCheckedKeys(this.appRoleValue);
                // this.$refs.appShowtree.setCheckedKeys(this.appShowValue);
                const arr1 = [];
                const arr2 = [];
                const arr3 = [];
                this.$nextTick(() => {
                    this.pcValue.forEach((item) => {
                        if (!this.$refs.pctree.getNode(item).childNodes || !this.$refs.pctree.getNode(item).childNodes.length) {
                            arr1.push(item);
                        }
                    });
                    this.$refs.pctree.setCheckedKeys(arr1);
                });
                this.$nextTick(() => {
                    this.appRoleValue.forEach((item) => {
                        if (!this.$refs.apptree.getNode(item).childNodes || !this.$refs.apptree.getNode(item).childNodes.length) {
                            arr2.push(item);
                        }
                    });
                    this.$refs.apptree.setCheckedKeys(arr2);
                });
                this.$nextTick(() => {
                    this.appShowValue.forEach((item) => {
                        if (!this.$refs.appShowtree.getNode(item).childNodes || !this.$refs.appShowtree.getNode(item).childNodes.length) {
                            arr3.push(item);
                        }
                    });
                    this.$refs.appShowtree.setCheckedKeys(arr3);
                });
            });
            // 获取App权限信息
            // get(url.menu.ownMenu, {
            //     companyId: id,
            //     application: 'App'
            // }).then(res => {
            //     this.appValue = res.data;
            // });
            // 获取基本信息
            get(url.company.base + id).then((res) => {
                let data = res.data;
                if (data.tenant.functions != null) {
                    data.tenant.functions = data.tenant.functions.split(',');
                    this.addForm.tenant.functions = data.tenant.functions;
                    if (data.tenant.functions.length == this.pcOptions.length) {
                        this.PCcheckAll = true;
                    } else {
                        this.PCcheckAll = false;
                    }
                }

                if (data.tenant.appFunctions != null) {
                    data.tenant.appFunctions = data.tenant.appFunctions.split(',');
                    // let filterData = data.tenant.appFunctions.filter(item => {
                    //     return item.length !== 4 && item.length !== 0;
                    // });
                    this.addForm.tenant.appFunctions = data.tenant.appFunctions;
                    if (this.addForm.tenant.appFunctions.length == this.AppOptions.length) {
                        this.APPcheckAll = true;
                    } else {
                        this.APPcheckAll = false;
                    }
                }

                this.addForm.tenant.id = data.tenant.id;

                this.addForm.company.name = data.company.name;
                this.$set(this.addForm.company, 'smartSiteUrl', data.company.smartSiteUrl == null ? '' : data.company.smartSiteUrl);
                // this.addForm.company.smartSiteUrl = data.company.smartSiteUrl;
                this.imageUrl = data.company.logoUrl ? `${url.imgUrl}/logo/${data.company.logoUrl.split('logo/')[1]}` : '';
                console.log('imgUrl', this.imageUrl);
                this.addForm.company.state = data.company.state;
                this.addForm.company.id = data.company.id;
                console.log(this.addForm.company.id);
                this.addForm.company.registrationDate = data.company.registrationDate.split(' ')[0];

                if (data.companyUserVos.length > 0) this.managerList.lists = [];
                for (let manager of data.companyUserVos) {
                    let { userName, tel, id } = manager;
                    this.managerList.lists.push({
                        userNameOld: userName,
                        userName: userName,
                        tel: tel,
                        telOld: tel,
                        editStatus: '',
                        id: id
                    });
                }
                this.dialogAddVisible = true;
            });
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //批量删除
        batchRemove: function () {
            if (this.sels.length > 0) {
                var ids = this.sels.map((item) => item.id).toString();
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.listLoading = true;
                        let para = { ids: ids };
                        deletes(url.expert.expertDelete + '?ids=' + ids, para).then((res) => {
                            this.listLoading = false;
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.getRole();
                        });
                    })
                    .catch(() => {});
            } else {
                this.$message.error('请先选择需要删除的数据！');
            }
        },
        deleteManager(row) {
            row.editStatus = '9';
            console.log(this.managerList);
        },
        resetPwd(row) {
            this.$confirm('确认重置密码吗？', '提示', {
                type: 'warning'
            }).then(() => {
                patch(url.fun.resetPwd + '?companyUserId=' + row.id)
                    .then((res) => {
                        this.$message({
                            message: '重置成功',
                            type: 'success'
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.funDialogVisible = false;
                        }, 1000);
                    });
            });
        },
        addManager(listindex) {
            this.managerList.lists.splice(listindex + 1, 0, {
                userName: '',
                tel: '',
                editStatus: '1'
            });
        },
        handleChange(value, direction, movedKeys) {
            this.chooseFrom.functions = value;
        },
        saveFun() {
            put(url.fun.addcomFunctionSet, this.chooseFrom)
                .then((res) => {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.funDialogVisible = false;
                    }, 1000);
                });
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            this.imageUrl = URL.createObjectURL(file);
            this.addForm.file = file;
            return false;
        },
        // app权限、显示树事件
        addAppRoleId(node, instanceId) {
            let id = node.id;
            if (node.children) {
                this.appShowValue.includes(id) ? console.log(id) : this.appShowValue.push(id);
                this.dealTreeData(node.children);
            } else {
                if (this.appShowValue.includes(id)) {
                    console.log('id');
                } else {
                    this.appShowValue.push(id);
                }
            }

            console.log('R1', node, instanceId);
        },
        // 递归处理数据
        dealTreeData(nodeObj) {
            for (let i = 0; i < nodeObj.length; i++) {
                if (this.appShowValue.includes(nodeObj[i].id)) {
                    console.log('id');
                } else {
                    this.appShowValue.push(nodeObj[i].id);
                }
                if (nodeObj[i].children) {
                    this.dealTreeData(nodeObj[i].children, type);
                }
            }
            return;
        },
        dealTreeData2(nodeObj) {
            console.log('appShowValue', this.appShowValue);
            for (let i = 0; i < nodeObj.length; i++) {
                if (this.appShowValue.includes(nodeObj[i].id)) {
                    for (let j = 0; j < this.appShowValue.length; j++) {
                        if (this.appShowValue[j] == nodeObj[i].id) {
                            this.appShowValue.splice(j, 1);
                        }
                    }
                } else {
                    console.log('nodeId', nodeObj);
                }
                if (nodeObj[i].children) {
                    this.dealTreeData(nodeObj[i].children);
                }
            }
        },
        deleteAppRoleId(node, instanceId) {
            console.log('R2', node, instanceId);
            let id = node.id;
            if (node.children) {
                if (this.appShowValue.includes(id)) {
                    for (let i = 0; i < this.appShowValue.length; i++) {
                        if (this.appShowValue[i] == id) {
                            this.appShowValue.splice(i, 1);
                        }
                    }
                }
                this.dealTreeData2(node.children);
            } else {
                if (this.appShowValue.includes(id)) {
                    for (let i = 0; i < this.appShowValue.length; i++) {
                        if (this.appShowValue[i] == id) {
                            this.appShowValue.splice(i, 1);
                            return;
                        }
                    }
                }
            }
        },
        addAppShowId(node, instanceId) {
            // console.log('s1', node, instanceId);
        },
        deleteAppShowId(node, instanceId) {
            // console.log('s2', node, instanceId);
        },

        // 认证同步
        synchroData() {
            this.$confirm('是否开始认证中心数据同步', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.btnClickStatus = true;
                    let instance = axios.create();
                    instance.defaults.headers.post['Content-Type'] = 'application/json';
                    instance
                        .post(url.authentication.synchroTenant, {})
                        .then((res) => {
                            if (res.data.code == 200) {
                                this.btnClickStatus = false;
                                this.$message.success('正在同步租户,请稍后');
                            } else {
                                this.btnClickStatus = false;
                                this.$message.error(res.data.msg);
                            }
                        })
                        .catch(() => {
                            this.btnClickStatus = false;
                            this.$message.error(res.msg);
                        });
                })
                .catch(() => {
                    this.btnClickStatus = false;
                    this.$message.info('已取消同步');
                });

            // instance
            //     .post(url.authentication.synchroCompany, { data: {} })
            //     .then(ress => {
            //         console.log('ress', ress);
            //         if (ress.data.code == 200) {
            //             this.$message.success('公司同步完毕,即将进行人员同步');
            //             instance
            //                 .post(url.authentication.synchroPeople, { data: {} })
            //                 .then(resss => {
            //                     console.log('resss', resss);
            //                     if (resss.data.code == 200) {
            //                         this.btnClickStatus = false;
            //                         this.$message.success('人员同步完毕,完成所有同步');
            //                     } else {
            //                         this.btnClickStatus = false;
            //                         this.$message.error(resss.data.msg);
            //                     }
            //                 })
            //                 .catch(() => {
            //                     this.btnClickStatus = false;
            //                     this.$message.error(resss.msg);
            //                 });
            //         } else {
            //             this.btnClickStatus = false;
            //             this.$message.error(ress.data.msg);
            //         }
            //     })
            //     .catch(() => {
            //         this.btnClickStatus = false;
            //         this.$message.error(ress.msg);
            //     });
        }
    }
};
</script>

<style scoped lang="scss">
.dz-zz-right-btn-box {
    float: right;
}
.dz-zz-right-btn-box .iconfont {
    font-size: 12px;
}
.dz-zz-right-btn-box .btn-green {
    background-color: #2eb976;
    border-color: #2eb976;
    color: #fff;
}
.dz-zz-right-btn-box .btn-green:hover {
    opacity: 0.8;
}
.dz-zz-right-btn-box .btn-blue {
    background-color: #1c9ba1;
    border-color: #1c9ba1;
    color: #fff;
}
.dz-zz-right-btn-box .btn-blue:hover {
    opacity: 0.8;
}
.dz-zz-btn-box {
    margin-top: 10px;
}
.dz-zz-btn-box .iconfont {
    font-size: 12px;
}
.dz-zz-table-box {
    margin-top: 15px;
}
.block {
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
}
.part_title {
    color: #000;
    position: relative;
    height: 40px;
    padding-left: 10px;
    font-size: 18px;
}
.part_title span {
    width: 5px;
    height: 20px;
    position: absolute;
    background: #052f6f;
    left: 0;
    top: 3px;
}
.function_box {
    /* border: 1px solid rgb(220, 223, 230); */
    /* padding: 5px; */
    height: 370px;
}
.appTree {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.function_box {
    // width: 254px !important;
    width: 80% !important;
}
.hide {
    color: white;
}
::v-deep.el-form {
    .el-tree {
        height: 400px !important;
        overflow-y: auto;
        .el-tree-node.is-expanded > .el-tree-node__children {
            .el-tree-node__children {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
            }
        }
        // .el-tree-node__content{
        //     span{
        //         &:nth-of-type(2){
        //             display: inline-block;
        //             width: 150px;
        //         }
        //     }
        // }
    }
}
.tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    /* padding-right: 8px; */
}
.over-ellipsis {
    display: block;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 1;
}

// ::v-deep.vue-treeselect {
//     .vue-treeselect__indent-level-1 {
//         display: flex;
//         justify-content: flex-start;
//     }
// }
//通过自定义树形结构行内容，实现文本过多时数据不显示的问题，现在效果为显示省略号，且鼠标移上去会显示出全部文本内容
.custom-tree-node {
    width: 100px;
    overflow: hidden !important; // 溢出部分隐藏
    white-space: nowrap !important; //禁止自动换行
    text-overflow: ellipsis !important; // 使溢出部分以省略号显示
    display: block !important;
    font-size: 20px;
}
</style>
